module.exports = __webpack_public_path__ + "img/vip_video_ok.234244bc.png";